/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
// Copyright 2021 channysok
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import React, { useEffect, useState } from "react";
import { Button} from 'react-bootstrap';
import { getToken, onMessageListener } from "./firebase";
import {  toast } from 'react-toastify';
const Hub2Notification = (props) => {

  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({title: '', body: ''});
  const [isTokenFound, setTokenFound] = useState(false);
  getToken(setTokenFound);

  const notify = ({title, message}) => toast(
    <div><h6><strong>{title}</strong></h6><p>{message}</p><small>Just now</small></div>, {
    position: "top-right",
    autoClose: false,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: 0,
  });

  onMessageListener().then(payload => {
    // setShow(true);
    // setNotification({title: payload.notification.title, body: payload.notification.body})
    notify({title: payload.notification.title, message: payload.notification.body})
  }).catch(err => console.log('failed: ', err));

  return (
    <>
      {/* <div style={{textAlign:'center'}}>
        {isTokenFound && <small> Notification permission enabled 👍🏻 </small>}
        {!isTokenFound && <small> Need notification permission ❗️ </small>}
        <Button onClick={() => notify({message: "Hello", title: "Title"})}>Show Toast</Button>
      </div> */}
    </>

  );
}

export default Hub2Notification;
